import SessionExpired from 'utils/session_expired';

export function handleApiError(message, error) {
  if (error?.status === 401) {
    return SessionExpired.renewSessionModal(location.href);
  }

  if (error?.status === 422) return;

  toastr.error(message || 'Ocorreu um erro, tente novamente.');

  if (!error?.errors) {
    if (message) Rollbar.error(message, error);
    return;
  }

  const errorKey = Object.keys(error.errors)[0];
  if (!errorKey) return;

  const errorMsgs = error.errors[errorKey];
  const errorMsg = (errorMsgs.length && errorMsgs[0]) || '';

  Rollbar.error(
    `API response error${errorMsg && `: ${errorKey} ${errorMsg}`}.`,
    {
      status: error.status,
      statusText: error.statusText,
      responseText: error.responseText
    }
  );
}
